import { render, staticRenderFns } from "./WaitingForCustoms.vue?vue&type=template&id=331f36d9&"
import script from "./WaitingForCustoms.vue?vue&type=script&lang=js&"
export * from "./WaitingForCustoms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports